import React, {Component} from 'react';
import OrariLavoratoriContainer from "./Orari/container";

class GeoLavoratoriComponent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <OrariLavoratoriContainer/>;
    }
}

export default GeoLavoratoriComponent;

